import React from 'react';
import { Snackbar, Alert } from '@mui/material';

const AppSnackbar = ({ open, onClose, message, severity = 'success', autoHideDuration = 2000 }) => {
  return (
    <Snackbar
      open={open}
      autoHideDuration={autoHideDuration}
      onClose={onClose}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
    >
      <Alert
        onClose={onClose}
        severity={severity}
        sx={{
          background:
            severity === 'success'
              ? 'linear-gradient(90deg, #E54004 0%, #F6911D 100%)'
              : 'linear-gradient(90deg, #D32F2F 0%, #FF6F61 100%)',
          color: 'white',
          '& .MuiAlert-icon': { color: 'white' },
        }}
      >
        {message}
      </Alert>
    </Snackbar>
  );
};

export default AppSnackbar;
